/* eslint-disable no-useless-escape */

export const addDeviceRegexp = {
  dns: /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/,
  ip: /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/,
  localhost: /^localhost$/,
  serialNumber: /^[A-Za-z0-9]{2}(:[A-Za-z0-9]{2}){5}$/,
};
